import { H6, Spinner } from '@blueprintjs/core';
import {
  heartbeat_hooks,
  assignment_hooks,
} from '@axo/shared/data-access/hooks';
import { assignment } from '@axo/shared/data-access/types';
import styles from './PortfolioNavigation.module.css';

export const MAX_NUMBER_OF_ASSIGNMENTS = 5;

export function UnprocessedTooltipManager({
  marketCountry,
  unprocessedStats,
}: {
  marketCountry: string;
  unprocessedStats: assignment.UnprocessedCount;
}) {
  const heartbeats = heartbeat_hooks.useHeartbeats(marketCountry);
  const count = assignment_hooks.useCountAssignments(marketCountry);
  if (heartbeats.isLoading || count.isLoading) return <Spinner />;
  const now = new Date();
  const numOperatorsOnline =
    heartbeats.error || !heartbeats.data
      ? '?'
      : heartbeats.data.Items.filter((x) => new Date(x.DeactivatesAt) > now)
          .length;
  const maxedOperators = count.data?.Items.filter(
    (x) => x.NumAssignments >= MAX_NUMBER_OF_ASSIGNMENTS,
  );
  return (
    <div className={styles.unprocessedTooltip}>
      <table className={styles.tooltipTable}>
        <tbody>
          <tr>
            <th align="left">
              <H6>Applications processing:</H6>
            </th>
          </tr>
          <tr>
            <td>Unprocessed:</td>
            <td align="right">
              {unprocessedStats.NumActive + unprocessedStats.NumQueue}
            </td>
          </tr>
          <tr>
            <td>Processing:</td>
            <td align="right">
              {unprocessedStats.NumActive}/
              {unprocessedStats.NumActive + unprocessedStats.NumQueue}
            </td>
          </tr>
          <tr>
            <td>Operators Online:</td>
            <td align="right">{numOperatorsOnline}</td>
          </tr>
          <tr>
            <td>Operators with max.</td>
            <td align="right">{maxedOperators?.length}</td>
          </tr>
        </tbody>
      </table>
    </div>
  );
}
